import { useCallback, useEffect, useMemo, useState } from "react";
import { AprobarSolicitudesHEDTO, DetalleRegimenLaboralHEDTO, solicitudesUnidad } from "./typesAprobarSolicitudHE"
import { Col, Container, Row, Table } from "react-bootstrap";
import { Button, Label, Input, PaginationItem, PaginationLink, Pagination } from "reactstrap";
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg";
import React from "react";
import CardRegimenHE from "components/DirectivoUnidad/Horas Extras/PlanificacionHE/CardRegimenHE";
import { EnvioInfoDocPagoEspol, EnvioSolicitudRechazada, FirmarEnviarSolicitudNominaTH, FirmaTodasSolicitudesNominaTH, GuardarDocumentoSolicitudPE, ObtenerDocGuardado, obtenerInfoRegimenPlan, obtenerInfoSolicitudes, obtenerMesesAprob, obtenerNumSolicitudesUnidad, ObtenerReporteExcelSolAprob, VistaPreviaPagoEspol, VistaPreviaSolicitudHETHoUsuario } from "./functionsAprobarSolicitudesHE";
import { showAlert, showAlertAviso } from "../Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import MonthDatePicker from "components/Varios/DatePicker/MonthDatePicker";
import ModalConfirmacion from "components/Varios/Modals/ModalConfirmacion";
import { ReactComponent as IconPdf } from "../../../../assets/icons/HorasExtras/PDF.svg"
import { ReactComponent as FirmaIcon } from "../../../../assets/icons/HorasExtras/firma.svg"
import { ReactComponent as IconX } from "../../../../assets/icons/HorasExtras/X.svg"
import { ReactComponent as IconCheck } from "../../../../assets/icons/HorasExtras/Chek.svg"
import { listadoMeses, ObtenerFechaFromIsoFormat, sendDateToBackend } from "../../../../functions/DatesFunctions";
import ModalVistaPreviaDocumentos from "components/Varios/Modals/ModalVistaPreviaDocumentos";
import { VistaPreviaSolicitudHEIngresada } from "components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/FunctionsSolicitudPagoHE";
import ModalRechazo from "components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud";
import ModalVistaPreviaDocumento from "components/Varios/Modals/ModalVistaPreviaDocumento";
import { info } from "pdfjs-dist/types/shared/util";
import ModalCargando from "../../../Varios/ModalCargando";
import TableAprobarSolicitudes from "./TableAprobarSolicitudes";
import TextEditor from "components/Varios/TextEditor";
import ModalFirmarPDF from "components/Varios/Modals/ModalFirmarPDF";
import ExitoSVG from "./../../../../assets/icons/HorasExtras/Exitosa.svg"
import ErrorSVG from "./../../../../assets/icons/HorasExtras/Error.svg"
import DatePickerBlueColor from "components/Varios/DatePicker/DatePickerBlueColor";
import { InfoDoc } from "../Revision Documento Pago Horas Extras/typesDocumentoPagoEspolHE";

export function RevisarSolicitudesHE() {

    const fechaHoy = new Date();
    const fechaInicio = new Date(`${fechaHoy.getMonth() + 1}/1/${fechaHoy.getFullYear()}`);

    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [loadingAccion, setloadingAccion] = useState<boolean>(false);
    const [loading, setloading] = useState<boolean>(false);
    const [loadingDocumentoPago, setloadingDocumentoPago] = useState<boolean>(false);

    const [detalleRegimen, setdetalleRegimen] = useState<DetalleRegimenLaboralHEDTO[]>([]);
    const [infoSolicitudes, setinfoSolicitudes] = useState<AprobarSolicitudesHEDTO[]>([]);
    const [docGuardado, setdocGuardado] = useState<InfoDoc | null>(null);
    const [solicitudesUnidad, setsolicitudesUnidad] = useState<solicitudesUnidad[]>([]);
    const [listaMeses, setlistaMeses] = useState<string>("");
    const [idConsultaEstructura, setidConsultaEstructura] = useState<number | undefined>(undefined);
    const [generarPdf, setgenerarPdf] = useState<boolean>(false);
    const [TextoPagoEspol, setTextoPagoEspol] = useState<string>("");
    const [urlDocPagoEspol, seturlDocPagoEspol] = useState<string>("");
    const [tituloModal, settitulomodal] = useState<string>("");
    const [contenidoCarta, setcontenidoCarta] = useState<string>("");
    const [desdefecha, setdesdefecha] = useState<Date | null>(fechaInicio);
    const [hastafecha, sethastafecha] = useState<Date | null>(fechaHoy);

    const [desdeFechaISO, setdesdeFechaISO] = useState<string>("");
    const [hastaFechaISO, sethastaFechaISO] = useState<string>("");

    const [mes, setmes] = useState<number | null>(fechaHoy.getMonth() + 1);
    const [anio, setanio] = useState<number | null>(fechaHoy.getFullYear());
    const [anioPresentar, setanioPresentar] = useState<number | null>(null);
    const [actualizar, setactualizar] = useState<boolean>(false);

    const [ordenAsc, setOrdenAsc] = useState<boolean>(true);

    const [sortColumn, setSortColumn] = useState<string | null>('');
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fecha = new Date();
        setmes(fecha.getMonth() + 1);
        setanioPresentar(fecha.getFullYear());
    }, []);

    useEffect(() => {
        if (desdefecha && hastafecha) {
            setdesdeFechaISO(`${desdefecha.getFullYear()}-${String(desdefecha.getMonth() + 1).padStart(2, '0')}-${String(desdefecha.getDate()).padStart(2, '0')}`);
            sethastaFechaISO(`${hastafecha.getFullYear()}-${String(hastafecha.getMonth() + 1).padStart(2, '0')}-${String(hastafecha.getDate()).padStart(2, '0')}`);
        }
    }, [desdefecha, hastafecha])

    useEffect(() => {
        if (desdeFechaISO != "" && hastaFechaISO != "") {
            numSolicitudesUnidad(desdeFechaISO, hastaFechaISO);
            MesesAprobadosOrdenados(desdeFechaISO, hastaFechaISO);
            ObtenerDocumento();
        }
    }, [desdeFechaISO, hastaFechaISO, generarPdf])

    useEffect(() => {
        //const mesSeleccionado = listadoMeses.find(m => m.valorMes == mes);
        //const mesDefault = listadoMeses.find(m => m.valorMes == (fechaHoy.getMonth() + 1));

        //const nombreMes = mesSeleccionado ? mesSeleccionado.mes.toLowerCase() : mesDefault?.mes;

        const mesLista = listaMeses.split(',');

        const textoMes = mesLista.length > 1 ? `a los meses de ${listaMeses}` : `al mes de ${listaMeses}`;

        const textoHTML = '<div style="text-align: justify;">\
    <p>Por medio del presente, la Dirección de Talento Humano informa que se ha realizado la revisión, validación y \
       consolidación de las horas suplementarias y extraordinarias correspondientes ' + textoMes + ' del ' + anioPresentar + ', .Se confirma que los cálculos,\
       montos y soportes cumplen con la normativa legal e institucional vigente. <br /> <br />\
       En atención a lo expuesto, se solicita a la Gerencia Financiera, emitir la Certificación Presupuestaria correspondiente,\
       con la finalidad de garantizar la disponibilidad de recursos para el pago de las horas suplementarias y extraordinarias\
       revisadas.<br/> <br/>  \
       Una vez emitida la certificación, se solicita a la Gerencia Administrativa que proceda con la emisión de \
       la autorización de pago.Para el efecto, se presenta el siguiente cuadro resumen de valores, conforme a la nómina del \
       personal correspondiente ' + textoMes + ' del ' + anioPresentar + ', que ejecutó horas suplementarias y extraordinarias dentro de \
       la planificación mensual. </p >\
</div>'

        // const texto = "De mi consideración:<br/>La Dirección de Talento Humano, de acuerdo a lo establecido en el Art. 114 de la LOSEP en concordancia con " +
        //     "el Art. 268 de su reglamento de aplicación, el PROCESO PRO - DHO-036 Gestión de Pago de Horas Extras y toda vez que la Gestión de Nómina, realizó " +
        //     "la respectiva revisión, determinando el tiempo efectivo de trabajo en horas suplementarias y extraordinarias, efectuando el cruce de información " +
        //     "entre el control de asistencia y los formularios de horas extras firmados por los servidores y autorizados por su jefe inmediato, cumple en remitir, " +
        //     "la nómina del personal correspondiente al mes de " + listaMeses + " del " + anioPresentar + ", que ejecutó horas suplementarias y extraordinarias autorizadas " +
        //     "por la autoridad nominadora, en la respectiva planificación anual de acuerdo al archivo que se anexa:"
        if (generarPdf) {
            setTextoPagoEspol(textoHTML)
        }

    }, [listaMeses, anioPresentar, generarPdf])

    const onClickRow = useCallback(
        async (idConsultaEstructura) => {
            if (idConsultaEstructura && desdeFechaISO && hastaFechaISO) {
                await obtenerInfoSolicitudyRegimen(desdeFechaISO, hastaFechaISO, mes, anioPresentar, idConsultaEstructura);
            }
        },
        [idConsultaEstructura, mes, anioPresentar, desdeFechaISO, hastaFechaISO],
    )

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    
    //reorganiza ascendente o descendente los nombres
    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };

    const applySorting = (data) => {
        if (!sortColumn) return data;

        if (data) {
            const sortedData = [...data].sort((a, b) => {
                if (a && b) {
                    var valA = a[sortColumn];
                    var valB = b[sortColumn];

                    if (typeof valA === "string" && typeof valB === "string") {
                        // Sort strings using localeCompare
                        return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                    } else if (typeof valA === "number" && typeof valB === "number") {
                        // Sort numbers directly
                        return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                    }

                    // Handle potential cases where types are mixed or unexpected
                    return 0;
                }

                return 0;


            });
            return sortedData;
        }

    };


    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };
    //filtrado para el buscador
    const filteredSolicitudes = (solicitudesUnidad && solicitudesUnidad.length > 0) ? solicitudesUnidad.filter(solic =>
        (solic.unidad.toLowerCase().includes(searchTerm.toLowerCase()))
    ) : [];

    //presenta las filas asignadas
    const sortedSolicitudes = applySorting(filteredSolicitudes);
    let currentRows = sortedSolicitudes.slice(indexOfFirstRow, indexOfLastRow);

    //obtiene el numero de paginas segun la cantidad de datos
    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredSolicitudes.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    async function obtenerInfoSolicitudyRegimen(desde: string, hasta: string, mes: number | null, anio: number | null, id: number | null) {
        setloadingAccion(true);
        if (anio && mes && id) {
            const solicitudesInfo = await obtenerInfoSolicitudes(desde, hasta, id);
            const regimenPlanificado = await obtenerInfoRegimenPlan(mes, anio, id);

            //Planificacion por Regimen
            if (regimenPlanificado.status == 200 && regimenPlanificado.dataResponse) {
                var tablaRegimen = regimenPlanificado.dataResponse;
                setdetalleRegimen(tablaRegimen);
                setErrorMessage(null);
                setactualizar(true);
            } else {
                setdetalleRegimen([]);
                setErrorMessage(typeof regimenPlanificado.errorMessage === 'string' ? regimenPlanificado.errorMessage : 'Error desconocido');
                showAlert(typeof regimenPlanificado.errorMessage === 'string' ? regimenPlanificado.errorMessage : 'Error desconocido', false);
                setactualizar(false);
            }
            //Solicitudes de Horas Extras
            if (solicitudesInfo.status == 200 && solicitudesInfo.dataResponse) {
                var tablaSolicitud = [...solicitudesInfo.dataResponse];
                tablaSolicitud.map((ts) => {
                    ts.fechaSolicitud = ObtenerFechaFromIsoFormat(ts.fechaSolicitud);
                });
                setinfoSolicitudes(tablaSolicitud);
                setErrorMessage(null);
                setactualizar(true);
                // setidConsultaEstructura(undefined);
            } else if (solicitudesInfo.status == 409) {
                showAlertAviso(typeof solicitudesInfo.errorMessage === 'string' ? solicitudesInfo.errorMessage : 'Error desconocido');
                setactualizar(false);
                // setidConsultaEstructura(undefined);
            }
            else {
                setinfoSolicitudes([]);
                setErrorMessage(typeof solicitudesInfo.errorMessage === 'string' ? solicitudesInfo.errorMessage : 'Error desconocido');
                showAlert(typeof solicitudesInfo.errorMessage === 'string' ? solicitudesInfo.errorMessage : 'Error desconocido', false);
                setactualizar(false);
                // setidConsultaEstructura(undefined);
            }

        }
        setloadingAccion(false);
    };

    async function ObtenerDocumento() {
        const documneto = await ObtenerDocGuardado();
        if (documneto.status == 200 && documneto.dataResponse) {
            setdocGuardado(documneto.dataResponse);
        }
        else if (documneto.status == 200 && !documneto.dataResponse) {
            setdocGuardado(null);
        }
        else {
            setErrorMessage(typeof documneto.errorMessage === 'string' ? documneto.errorMessage : 'Error desconocido');
            showAlert(typeof documneto.errorMessage === 'string' ? documneto.errorMessage : 'Error desconocido', false);
        }
    }



    // const actualizacion = useCallback(
    //     () => {
    //         if (idConsultaEstructura) {

    //             //setinfoSolicitudes([]);
    //             onClickRow(idConsultaEstructura);
    //             if (infoSolicitudes.length < 1) {
    //                 setactualizar(false);
    //             }
    //         }
    //     },
    //     [idConsultaEstructura, infoSolicitudes],
    // )

    async function MesesAprobadosOrdenados(desde: string, hasta: string) {
        const mesesAprob = await obtenerMesesAprob(desde, hasta);
        if (mesesAprob.status == 200 && mesesAprob.dataResponse) {
            const mesesA = mesesAprob.dataResponse;
            if (mesesA.length > 0) {
                var mesesTexto = mesesA[0];
                for (let i = 1; i < mesesA.length; i++) {
                    mesesTexto = mesesTexto + ", " + mesesA[i];
                }
                setlistaMeses(mesesTexto);
            }
            else {
                setlistaMeses("");
            }
        }
        else {
            setErrorMessage(typeof mesesAprob.errorMessage === 'string' ? mesesAprob.errorMessage : 'Error desconocido');
            showAlert(typeof mesesAprob.errorMessage === 'string' ? mesesAprob.errorMessage : 'Error desconocido', false);
        }

    }

    async function numSolicitudesUnidad(desde: string, hasta: string) {
        setloadingAccion(true);
        const numSolicitudes = await obtenerNumSolicitudesUnidad(desde, hasta);
        if (numSolicitudes.status == 200 && numSolicitudes.dataResponse) {
            var listaUnidadNumSol = numSolicitudes.dataResponse;
            setsolicitudesUnidad(listaUnidadNumSol);
            handleSort("unidad");
            setErrorMessage(null);
        } else {
            setsolicitudesUnidad([]);
            setErrorMessage(typeof numSolicitudes.errorMessage === 'string' ? numSolicitudes.errorMessage : 'Error desconocido');
            showAlert(typeof numSolicitudes.errorMessage === 'string' ? numSolicitudes.errorMessage : 'Error desconocido', false);
        }
        setloadingAccion(false);
    }

    async function onChangeValue(e: any) {
        var valor = e.target.value
        if (valor) {
            valor = +valor;
        }
        setanio(valor);
        //setTextoPagoEspol(contenidoCarta);
    }

    async function handletextoPDF(contenidoCarta: string) {
        setTextoPagoEspol(contenidoCarta);
    }

    const resumenDocPdf = useCallback(() => {
        return (
            <React.Fragment>
                <div className="titulo_blue">
                    RESUMEN DEL DOCUMENTO
                </div>
                <div>
                    <label style={{ marginLeft: '15px' }}>Dirigido a:</label>
                    <Container className="containerdireccionDoc" title="Dirigido a:">
                        Jefe de Presupuesto,   Gerente Financiero,     Gerente Administrativo

                    </Container>
                    <br></br>
                    <label style={{ marginLeft: '15px' }}>Solicitudes realizadas en el mes de:</label>
                    <Row className="d-flex align-items-center justify-content-start" >
                        <select
                            className="containerOptionStyle"
                            value={mes ? mes : 0}
                            style={{ marginLeft: '30px', width: '100px' }}
                            onChange={(e: any) => {
                                var valor = e.target.value
                                if (valor) {
                                    valor = +valor;
                                }
                                setmes(valor);
                                //setTextoPagoEspol(contenidoCarta);
                            }}>
                            {listadoMeses.map((lm, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <option value={lm.valorMes} > {lm.mes} </option>
                                    </React.Fragment>
                                )
                            })}
                        </select>
                        <input className="containerOptionStyle"
                            value={anio ?? fechaHoy.getFullYear()}
                            style={{ marginLeft: '10px', width: '100px', height: '22px' }}
                            maxLength={4}
                            type="text"
                            placeholder="Año"
                            onChange={(e) =>
                                onChangeValue(e)
                            } />
                    </Row>
                    <br></br>
                    <Container>
                        <TextEditor
                            onChange={(nuevoTexto: string) => handletextoPDF(nuevoTexto)}
                            value={TextoPagoEspol}
                            className={"editorTexto"}
                        />
                    </Container>
                </div>
            </React.Fragment>
        )
    }, [mes, TextoPagoEspol])

    //tremos el documento pdf al front
    async function generacionPDF(desde: string | null, hasta: string | null) {

        if (desde && hasta) {
            setloadingDocumentoPago(true)
            const respuestaVistaPrevia = await VistaPreviaPagoEspol(desde, hasta);
            if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
                seturlDocPagoEspol(respuestaVistaPrevia.dataResponse);
                setloadingDocumentoPago(false)

            }
            else {
                showAlert("No es posible cargar la vista previa del documento", false);
                setloadingDocumentoPago(false)
            }
        }

    }

    async function FirmarDocumentoAutorizar(solicitudes: solicitudesUnidad[], objeto: any) {
        var contrasenia = objeto.contrasenia;
        var filesData = objeto.filesEnviar;

        if (contrasenia && filesData.length > 0) {
            var datosRequest = new FormData();
            datosRequest.append("contrasenia", contrasenia);
            datosRequest.append("idpersona", '0');
            filesData.map((fData) => {
                datosRequest.append("files", fData.file, fData.file.name);
            });
            const solicitudesJSON = JSON.stringify(solicitudes);
            datosRequest.append("dataServidorSave", solicitudesJSON);
            // const textoDoc = JSON.stringify(texto);
            // datosRequest.append("dataServidorSave",textoDoc);


            var accionRealizada = await GuardarDocumentoSolicitudPE(datosRequest)
            if (accionRealizada.status === 200) {
                showAlert("El documento se ha firmado y enviado correctamente.", true);
                seturlDocPagoEspol("");
                //setstateinformacionModalGuardarPlanificacion(defaultStateInformacionModalGuardarPlanificacion)
                //await ObtenerInformacionGeneral();
            } else if (accionRealizada.status == 409) {
                showAlert(accionRealizada.errorMessage ?? "error desconocido", false);
                //await ObtenerInformacionGeneral();
            } else {
                showAlert("Error Desconocido, no se pudo firmar", false);
                //await ObtenerInformacionGeneral();
            }
        }
    }

    // enivamos y almacenamos el contenido para el documento al back
    async function envioInformacionPDF(objeto, desde: string | null, hasta: string | null, mes: number | null, anio: number | null) {
        // var objeto = {contenido, texto};
        setloading(true);
        if (mes && anio && desde && hasta) {
            const DocumentoCreado = await EnvioInfoDocPagoEspol(objeto, mes, anio, desde, hasta);
            if (DocumentoCreado.status == 200) {
                //showAlert("Se ha guardado el contenido del documento correctamente", true);
                await generacionPDF(desde, hasta);
                setloading(false);
                return 1;
            }
            else {
                showAlert(DocumentoCreado.errorMessage ?? "Ha ocurrido un error y no se guardo el contenido correctamente", false);
                setloadingAccion(false);
                return -1;
            }
        }
        return 1;
    }

    async function ReporteExcel(desde: string | null, hasta: string | null) {
        setloadingAccion(true);
        if (desde && hasta) {
            const reporteExcel = await ObtenerReporteExcelSolAprob(desde, hasta);
            if (reporteExcel.status == 200) {
                console.log("Success");
            }
            else {
                showAlertAviso("No existen solicitudes revisadas para realizar el reporte");
            }
        }
        setloadingAccion(false);
    }

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {detalleRegimen.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHE
                                regimenLaboralPlan={regimen}
                                index={index}
                                tipo="SOLICITUD"
                                idunidad={idConsultaEstructura }
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );

    const aprobacionTodos = useCallback(
        async (infoSolicitudes: AprobarSolicitudesHEDTO[] | null) => {
            if (desdeFechaISO && hastaFechaISO) {
                if (infoSolicitudes) {
                    infoSolicitudes.map((c) => {
                        const fecha = c.fechaSolicitud.split("/");
                        c.fechaSolicitud = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                    })
                    const respuestafirmas = await FirmaTodasSolicitudesNominaTH(infoSolicitudes);
                    if (respuestafirmas.status === 200) {
                        showAlert("Las solicitudes han sido revisadas y firmadas correctamente", true);
                        await numSolicitudesUnidad(desdeFechaISO, hastaFechaISO);
                        await ObtenerDocumento();
                        //setidConsultaEstructura(undefined);
                        return 1;
                    }
                    else {
                        const mensajeDefault = "Ha ocurrido un inconveniente al intentar firmar sus solicitudes de Horas Extras."
                        showAlert(respuestafirmas.errorMessage ?? mensajeDefault, false);
                        await numSolicitudesUnidad(desdeFechaISO, hastaFechaISO);
                        await ObtenerDocumento();
                        //setidConsultaEstructura(undefined);
                        return -1;
                    }
                }
                return 1;
            }
            return -1
        },
        [desdeFechaISO, hastaFechaISO],
    )

    async function onCloseTabla() {
        setidConsultaEstructura(undefined);
        setinfoSolicitudes([]);
        setactualizar(false);
        if (desdeFechaISO && hastaFechaISO) {
            await numSolicitudesUnidad(desdeFechaISO, hastaFechaISO);
            await ObtenerDocumento();
            await MesesAprobadosOrdenados(desdeFechaISO, hastaFechaISO);
        }
    }

    // const contenidoUnidad = useM(() => {
    //     if (infoSolicitudes.length > 0) {
    //         return (
    //             <React.Fragment>
    //                 {contenidoCardRegimen}
    //                 <TableAprobarSolicitudes
    //                     informacionContenido={infoSolicitudes}
    //                     actualizar={actualizacion}
    //                 />
    //             </React.Fragment>
    //         );
    //     }

    // }, [infoSolicitudes, detalleRegimen,idConsultaEstructura,actualizacion])

    const contenidoUnidad = useMemo(() => {


        const actualizacion = async () => {

            if (idConsultaEstructura && desdeFechaISO && hastaFechaISO) {
                const solicitudesInfo = await obtenerInfoSolicitudes(desdeFechaISO, hastaFechaISO, idConsultaEstructura);
                if (solicitudesInfo.dataResponse && solicitudesInfo.status == 200) {
                    setinfoSolicitudes([]);
                    var tablaSolicitud = [...solicitudesInfo.dataResponse];
                    tablaSolicitud.map((ts) => {
                        ts.fechaSolicitud = ObtenerFechaFromIsoFormat(ts.fechaSolicitud);
                    });
                    setinfoSolicitudes(tablaSolicitud);
                    //await onClickRow(idConsultaEstructura);
                }
                else if (!solicitudesInfo.dataResponse) {
                    setactualizar(false);
                }
            }
        }

        if (infoSolicitudes.length > 0) {
            return (
                <React.Fragment>
                    {contenidoCardRegimen}
                    <TableAprobarSolicitudes
                        informacionContenido={infoSolicitudes}
                        actualizar={() => actualizacion()}
                    />
                </React.Fragment>
            );
        }
    }, [infoSolicitudes, detalleRegimen, idConsultaEstructura, setinfoSolicitudes, /*onClickRow,*/ desdefecha, hastafecha])


    const ListadoUnidades = useCallback(() => {

        return (
            <React.Fragment>
                <div>
                    <Row>
                        <Col style={{ marginRight: 15 }}>
                            <Row className="justify-content-end">
                                {docGuardado && (
                                    <Button
                                        onClick={async () => {
                                            await generacionPDF(desdeFechaISO, hastaFechaISO);
                                        }}
                                        className="btn-PDF">
                                        <div className="containerBotonImprimir">
                                            <div>Firmar Doc Guardado</div>
                                            <FirmaIcon className="iconBotonImprimir" />
                                        </div>
                                    </Button>
                                )}
                                {!docGuardado && (
                                    <Button
                                        onClick={async () => {
                                            setgenerarPdf(true);
                                        }}
                                        className="btn-PDF">
                                        <div className="containerBotonImprimir">
                                            <div>Generar PDF</div>
                                            <IconPdf className="iconBotonImprimir" />
                                        </div>
                                    </Button>
                                )}
                                <Button
                                    onClick={() => {
                                        ReporteExcel(desdeFechaISO, hastaFechaISO);
                                    }}
                                    className="btn-Excel">
                                    <div className="containerBotonImprimir">
                                        <div>Exportar a Excel</div>
                                        <IconoExcel className="iconBotonImprimir" />
                                    </div>
                                </Button>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <div className="d-flex align-items-center justify-content-start">
                                <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                                <select
                                    id="rowsPerPageSelect"
                                    value={rowsPerPage}
                                    onChange={handleRowsPerPageChange}
                                    className="custom-select custom-select-sm mr-2"
                                    style={{ width: 'auto' }}
                                >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                </select>
                                <Label className="mb-0">filas</Label>
                            </div>
                        </Col>
                        <Col xs="3" md="3" className="d-flex align-items-end justify-content-end ml-auto">
                            <Input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={handleSearchChange}
                                className="form-control-sm" // Reduce el tamaño del input
                            />
                        </Col>
                    </Row>
                </div>
                {currentRows.length < 1 && (
                    <Label className={"font-15"}>
                        No Existen solicitudes para las fechas seleccionadas
                    </Label>
                )}
                {currentRows.length > 0 && (
                    <div className="table-responsive">
                        <Table>
                            <thead className="cabeceras_tabla_solicitudes_he">
                                <tr>
                                    <th colSpan={1} style={{ textAlign: "left" }} onClick={() => handleSort("unidad")}> Unidad</th>
                                    <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Recibidas</th>
                                    <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Revisadas</th>
                                    <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Por Revisar </th>
                                    <th colSpan={1} style={{ textAlign: "center" }}> #Solicitudes <br /> Reversadas </th>
                                </tr>
                            </thead>
                            {currentRows.map((su, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <tbody className="table_solicitudes_he">
                                            <tr className='rows_tabla_solicitudes_he' onClick={() => {
                                                onClickRow(su.idEstructuraOrg);
                                                setidConsultaEstructura(su.idEstructuraOrg);
                                                settitulomodal(su.unidad);
                                            }}>
                                                <td align="left"> {su.unidad} </td>
                                                <td align="center"> {su.solicitudes} </td>
                                                <td align="center"> {su.solicitudesAP} </td>
                                                <td align="center"> {su.solicitudesPA} </td>
                                                <td align="center"> {su.solicitudesRev} </td>
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                )
                            })}
                            {currentRows.length > 0 &&
                                <tfoot className="table_solicitudes_he">
                                    <tr className='rows_tabla_solicitudes_he'>
                                        <td align="right">Totales:</td>
                                        <td align="center">{currentRows.reduce((acc, row) => acc + row.solicitudes, 0)}</td>
                                        <td align="center">{currentRows.reduce((acc, row) => acc + row.solicitudesAP, 0)}</td>
                                        <td align="center">{currentRows.reduce((acc, row) => acc + row.solicitudesPA, 0)}</td>
                                        <td align="center">{currentRows.reduce((acc, row) => acc + row.solicitudesRev, 0)}</td>
                                    </tr>
                                </tfoot>
                            }
                        </Table>
                    </div>
                )}
            </React.Fragment>
        )
    }, [currentRows])

    return (
        <React.Fragment>
            <div className={"content"}>
                <div style={{ alignContent: 'center' }} className="titulo_seccion"> REVISION DE SOLICITUDES PARA EL PAGO DE HORAS EXTRAS</div>
                <br></br>
                <Row className="justify-content-start">
                    <Col xl={2}>
                        <label> Desde: </label>
                        <DatePickerBlueColor
                            value={desdefecha}
                            placeholderText={"Desde"}
                            onChange={(e) => {
                                setdesdefecha(e);
                            }}
                            color="blue"
                        />
                    </Col>
                    <Col xl={2}>
                        <label>Hasta: </label>
                        <DatePickerBlueColor
                            value={hastafecha}
                            placeholderText={"Hasta"}
                            onChange={(e) => {
                                sethastafecha(e);
                            }}
                            color="blue"
                        />
                    </Col>
                </Row>
                <Row className="d-flex justify-content-between align-items-center">
                    <Col md="auto">
                        <div className="titulo_seccion">Solicitudes del año {anioPresentar}</div>
                    </Col>
                    <Col md="auto">
                        {docGuardado && (
                            <div className={`alert-Documento alert-lado-derecho alert-no-enviado`}>
                                <div className="alert-message">
                                    <i className={` icono-estado fa fa-exclamation-triangle`}></i> Usted tiene un documento pendiente de firmar
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row className="">
                    <Col xl={12}>
                        {ListadoUnidades()}
                    </Col>
                </Row>
                <Pagination size="sm" className="pagination_planificacion_he">
                    {renderPageNumbers}
                </Pagination>
            </div>

            <ModalCargando
                show={loadingAccion != false}
                textoCargando='Cargando Datos'
                size='md'
                onClose={() => setloadingAccion(false)}
            />

            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={!loadingAccion && actualizar != false}
                size='xl'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Aprobar Todos'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => onCloseTabla()}
                //asyncOnClick={async () => await aprobacionTodos(infoSolicitudes)}
                //contentModal={contenidoUnidad()}
                contentModal={contenidoUnidad}
                tituloModal={tituloModal}
                classNameContainer="containerModalRevision"
                useContainer={true}
            />
            <ModalConfirmacion
                idModal="ModalEditarActividadHE"

                show={generarPdf != false && TextoPagoEspol != ""}
                size='xl'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                // nam
                mensajeConfirmacion=''
                nombreBotonAccion='Generar PDF'
                nombreBotonCerrarModal='Cancelar'
                classNameBotonAccion='mr-2 btnEspolPrimary btn btn-primary'
                classNameBotonCerrarModal2='btn-white-red btn btn-secondary'
                onClose={() => setgenerarPdf(false)}
                asyncOnClick={() => envioInformacionPDF({ solicitudes: solicitudesUnidad, texto: TextoPagoEspol }, desdeFechaISO, hastaFechaISO, mes, anio)}
                contentModal={resumenDocPdf()}
                tituloModal='SOLICITUD PARA EL PAGO DE HORAS EXTRAS'
                classNameContainer="containerModalRevision"
                useContainer={true}
            />
            <ModalFirmarPDF
                show={urlDocPagoEspol !== "" || loadingDocumentoPago}
                tituloModal='Firma Documento Solicitud de Pago Horas Extras ESPOL'
                admiteFirmaFisica={false}
                size="xl"
                urlArchivo={urlDocPagoEspol}
                onClose={() => { seturlDocPagoEspol(""); setloadingDocumentoPago(false); ObtenerDocumento(); }}
                cargandoDatos={loadingDocumentoPago}
                onClickFirma={async (objeto) => await FirmarDocumentoAutorizar(solicitudesUnidad, objeto)}
            />
        </React.Fragment>

    )

}